import { HttpStatusCode } from "axios";
import { alertConstants } from "../../helper/sweet-alert";
import freshmaProcessService from "../../apiServices/freshman/freshmanProcessService";
import { setMainStepProcess, setSubStepProcess } from "../../store/slices/freshman/freshmanProcessSlice";
import FreshmanProcessService from "../../apiServices/freshman/freshmanProcessService"
import { IFreshManSubStepPercentage } from "../../models/freshman/freshmanProcess";


export function getAllMainStepPercentage() {
  return async function (dispatch: any, getState: any) {
    let response = await FreshmanProcessService.getAllMainStepPercentage();
    if (response?.success === true) {
      dispatch(setMainStepProcess(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getSubStepsByMainStepId(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await FreshmanProcessService.getSubStepsByMainStepId(id);
    if (response?.success === true) {
      dispatch(setSubStepProcess(response.data));
    } else {
      console.log("error");
    }
  };
}

export function updateSubStepPercentage(
  data: IFreshManSubStepPercentage,
  callback?: Function
) {
  return async function (dispatch: any, getState: any) {
    let response = await FreshmanProcessService.updateSubStepPercentage(data);
    if (response?.success === true) {
      callback && callback(alertConstants.success);
    } else {
      callback && callback(alertConstants.error);
    }
  };
}

export function getFreshmanProcessVersion() {
  return async function (dispatch: any, getState: any) {
    let response = await FreshmanProcessService.getFreshmanProcessVersion();
    if (response?.success === true) {
    } else {
    }
  };
}